<template>
  <div class="bottom-nav-bar">
    <div 
      class="nav-item" 
      :class="{ active: activeTab === 'menu' }"
      @click="handleMenuClick"
    >
      <el-icon class="nav-icon"><Menu /></el-icon>
      <span class="nav-text">菜单</span>
    </div>
    <div 
      class="nav-item" 
      :class="{ active: activeTab === 'order' }"
      @click="handleOrderClick"
    >
      <el-icon class="nav-icon"><Plus /></el-icon>
      <span class="nav-text">下单</span>
    </div>
    <div 
      class="nav-item" 
      :class="{ active: activeTab === 'myorders' }"
      @click="handleMyOrdersClick"
    >
      <el-icon class="nav-icon"><Document /></el-icon>
      <span class="nav-text">我的订单</span>
    </div>
  </div>

  <!-- 下单选项模态弹窗 -->
  <el-dialog
    v-model="showOrderDialog"
    title="选择订单类型"
    width="90%"
    :modal="true"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    class="order-type-dialog"
    align-center
  >
    <div class="order-options">
      <div class="order-option-item" @click="handleSelectOrderType('/supermaster')">
        <div class="option-icon">
          <el-icon :size="32"><Document /></el-icon>
        </div>
        <div class="option-title">散单-超主点</div>
        <div class="option-desc">超主点镜片订单</div>
      </div>
      <div class="order-option-item" @click="handleSelectOrderType('/astigmatism')">
        <div class="option-icon">
          <el-icon :size="32"><Document /></el-icon>
        </div>
        <div class="option-title">散单-其他</div>
        <div class="option-desc">其他类型订单</div>
      </div>
      <div class="order-option-item" @click="handleSelectOrderType('/bulkorders')">
        <div class="option-icon">
          <el-icon :size="32"><Document /></el-icon>
        </div>
        <div class="option-title">批量-库存片</div>
        <div class="option-desc">批量订单</div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Menu, Plus, Document } from '@element-plus/icons-vue'

const route = useRoute()
const router = useRouter()
const showOrderDialog = ref(false)

// 根据当前路由确定活动标签
const activeTab = computed(() => {
  const path = route.path
  
  // 判断是否为下单相关页面
  if (path.includes('/supermaster') || path.includes('/astigmatism') || path.includes('/bulkorders')) {
    return 'order'
  }
  
  // 判断是否为我的订单页面
  if (path.includes('/user/orders') || path.includes('/admin/orders')) {
    return 'myorders'
  }
  
  // 其他情况显示菜单为活动状态
  return 'menu'
})

// 处理菜单点击 - 触发侧边栏显示/隐藏
const handleMenuClick = () => {
  // 在任何页面都可以触发侧边栏显示/隐藏
  window.dispatchEvent(new CustomEvent('toggle-sidebar'))
}

// 处理下单点击 - 显示下单选项弹窗
const handleOrderClick = () => {
  showOrderDialog.value = true
}

// 处理选择订单类型
const handleSelectOrderType = (path) => {
  showOrderDialog.value = false
  router.push(path)
}

// 处理我的订单点击
const handleMyOrdersClick = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
  if (userInfo.role === 'ADMIN') {
    router.push('/admin/orders')
  } else {
    router.push('/user/orders')
  }
}
</script>

<style scoped>
.bottom-nav-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: #fff;
  border-top: 1px solid #e4e7ed;
  display: none; /* 默认隐藏，仅在移动端显示 */
  z-index: 1999; /* 低于侧边栏和遮罩层，但高于普通内容 */
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  padding: 4px 0;
}

.nav-item:active {
  background-color: #f5f7fa;
}

.nav-item.active {
  color: #409EFF;
}

.nav-item.active .nav-icon {
  color: #409EFF;
}

.nav-icon {
  font-size: 24px;
  color: #909399;
  margin-bottom: 2px;
  transition: color 0.3s;
}

.nav-text {
  font-size: 12px;
  color: #909399;
  transition: color 0.3s;
}

.nav-item.active .nav-text {
  color: #409EFF;
}
/* 下单选项弹窗样式 */
.order-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 0;
}

.order-option-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #fff;
}

.order-option-item:hover {
  border-color: #409EFF;
  background-color: #f0f9ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
}

.order-option-item:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.1);
}

.option-icon {
  margin-bottom: 12px;
  color: #409EFF;
}

.option-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 4px;
}

.option-desc {
  font-size: 12px;
  color: #909399;
}

/* 弹窗样式优化 */
:deep(.order-type-dialog) {
  .el-dialog__body {
    padding: 20px;
  }
  
  .el-dialog__header {
    padding: 20px 20px 10px;
  }
}

/* 移动端显示 */
@media screen and (max-width: 768px) {
  .bottom-nav-bar {
    display: flex;
  }
  
  /* 为移动端内容区域添加底部内边距，避免内容被底部导航栏遮挡 */
  :global(.el-main) {
    padding-bottom: 80px !important;
  }
  
  /* 移动端弹窗样式优化 */
  :deep(.order-type-dialog) {
    .el-dialog {
      margin: 5vh auto !important;
      max-width: 90vw;
    }
    
    .order-option-item {
      padding: 20px;
    }
    
    .option-title {
      font-size: 15px;
    }
    
    .option-desc {
      font-size: 11px;
    }
  }
}
</style>

